/**
 * @generated SignedSource<<308cb0e6f85b402b807bfad829507fea>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespContentModuleLanding_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedContentModuleLandingVideo_viewer">;
  readonly " $fragmentType": "SbRespContentModuleLanding_viewer";
};
export type SbRespContentModuleLanding_viewer$key = {
  readonly " $data"?: SbRespContentModuleLanding_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespContentModuleLanding_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespContentModuleLanding_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedContentModuleLandingVideo_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "004f6dcfff3806c3f52c9bd6970cb4d6";

export default node;
